import { Box, Button, Divider, Flex, Modal, Paragraph, Text, TextButton } from '@zillow/constellation-10';
import { useCallback } from 'react';
import { useRouter } from 'next/router';
import { useSetTransactionInformationMutation } from 'src/store/localStorage/TransactionInformationStorageApi';
import { ePages } from '../utilities/ePages';
import { SPRUCE_PHONE_NUMBER } from 'src/constants';

export const NotYourState = () => {
  const router = useRouter();
  const [setInfo] = useSetTransactionInformationMutation();

  const notYourState = useCallback(() => {
    setInfo({ state: undefined });
    router.push(ePages.PaymentType);
  }, [router, setInfo]);

  return (
    <Modal.Root
      // Escape/backdrop dismissal intentionally left enabled: dismissing is equivalent to Cancel here.
      shouldAwaitInteractionResponse={false}
    >
      <Modal.Trigger>
        <TextButton data-testid="not-your-state-btn" css={{ margin: 0, textStyle: 'body-sm' }} type={'button'}>
          <Box css={{ textStyle: 'body-sm' }}>Not your state?</Box>
        </TextButton>
      </Modal.Trigger>
      <Modal.Portal>
        <Modal.Backdrop>
          <Modal.Content data-testid="not-your-state-modal">
            {/* Keep the close button outside Modal.Header so it is not part of the dialog's aria-labelledby subtree. */}
            <Modal.CloseButton />
            <Modal.Header>
              <Text css={{ textStyle: 'h5' }}>Not your state?</Text>
            </Modal.Header>
            <Divider />
            <Modal.Body>
              <Paragraph css={{ textAlign: 'left' }}>
                This action will disconnect the displayed state from your current session.
                <br />
                If the state that is being displayed does not match the state of the subject property you are making a
                payment for, please disconnect and change your selection as payment options and instructions differ by
                state. If you have any questions, please contact us at {SPRUCE_PHONE_NUMBER}.
              </Paragraph>
            </Modal.Body>
            <Divider />
            <Modal.Footer>
              <Flex
                css={{
                  gap: 'md',
                  justifyContent: 'center',
                  alignItems: 'center',
                  flexDirection: 'row',
                  display: 'flex',
                }}
              >
                <Modal.Close>
                  <TextButton data-testid="cancel-not-your-state-button">Cancel</TextButton>
                </Modal.Close>
                <Modal.Close>
                  <Button
                    data-testid="confirm-not-your-state-button"
                    tone={'critical'}
                    emphasis={'filled'}
                    type={'button'}
                    onClick={notYourState}
                  >
                    Disconnect
                  </Button>
                </Modal.Close>
              </Flex>
            </Modal.Footer>
          </Modal.Content>
        </Modal.Backdrop>
      </Modal.Portal>
    </Modal.Root>
  );
};
